module.exports = __webpack_public_path__ + "img/thumbnail_Takin_j_normal.c0e640d7.png";